const sessionKeys = {
  recaptchaToken: 'recaptchaToken'
}

export default sessionKeys
